import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './locales/en';
import de from './locales/de';
import ru from './locales/ru';
import fr from './locales/fr';

Vue.use(VueI18n);

export type RosiLang = 'en' | 'de' | 'ru' | 'fr';

function readInitialLocale(): RosiLang {
  if (typeof window === 'undefined') return 'en';
  if (typeof window.rosiLangRead === 'function') {
    try {
      const s = window.rosiLangRead();
      if (s === 'en' || s === 'de' || s === 'ru' || s === 'fr') return s;
    } catch {
      /* ignore */
    }
  }
  try {
    const s = localStorage.getItem('rosi.lang');
    if (s === 'en' || s === 'de' || s === 'ru' || s === 'fr') return s;
  } catch {
    /* ignore */
  }
  return 'en';
}

export const i18n = new VueI18n({
  locale: readInitialLocale(),
  fallbackLocale: 'en',
  messages: { en, de, ru, fr }
});
